module.exports = __webpack_public_path__ + "static/media/tiska.bfc2eb5d.gif";